import React from 'react';
import { Input as HeroInput, InputProps as HeroInputProps } from '@heroui/react';
import { cn } from '@/shared/lib/utils';

export interface InputProps extends Omit<HeroInputProps, 'color' | 'variant'> {
  error?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, leftIcon, rightIcon, type = 'text', ...props }, ref) => {
    return (
      <HeroInput
        ref={ref}
        type={type}
        label={label}
        isInvalid={!!error}
        errorMessage={error}
        startContent={leftIcon}
        endContent={rightIcon}
        className={cn(className)}
        variant="bordered"
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';